import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { SIGNUP } from 'configs/routeNames';
import { removeFromLocal } from './cache';
import { CACHED_AGENCY_FORM_DATA_KEY, CONTRACT_EMAIL_KEY } from 'app/modules/Auth/SignUp/utils/formUtils';

export const useRouteCleanup = () => {
  const location = useLocation();

  useEffect(() => {
    if (!location.pathname.includes(SIGNUP)) {
      removeFromLocal('otpTimeLeft');
      removeFromLocal('otpExpired');
      removeFromLocal(CACHED_AGENCY_FORM_DATA_KEY);
      removeFromLocal(CONTRACT_EMAIL_KEY);
    }
  }, [location]);
};
